import React from 'react';
import logo from '../images/techStart.png';

const NoAccess = () => {
    return <div className='content-middle text-center pl-3 pr-3'>
        <img src={logo} className="logo" alt="logo" />
        <p>You don't have permissions to see this page</p>
    </div>
}

export default NoAccess